export const nonNullable = <T>(value: T): value is NonNullable<T> =>
  value != null;

export const filterByBrandTagAndLocale = (
  locale: string,
  tags: string[],
  publishDetailsLocale: string
) =>
  tags.includes(process.env.GATSBY_CONTENTSTACK_BRAND_TAG as string) &&
  publishDetailsLocale === locale;

export const generateUrl = (url: string, baseUrl: string): string => {
  if (url.startsWith('http') || url.startsWith('//') || !baseUrl) {
    return url;
  }

  return `${baseUrl.replace(/\/$/g, '')}/${url.replace(/^\//g, '')}`;
};
